export default "__VITE_ASSET__TFSIG88Z__"